import { Container } from "@bryntum/schedulerpro";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";
import { getCompanyCamProject } from "../../../network/network.jsx";
import { showToast } from "../../../other/utils/utils.jsx";

export default class CompanyCamField extends Container {
  static get $name() {
    return "CompanyCamField";
  }

  static get type() {
    return "companycamfield";
  }

  static get configurable() {
    return {
      items: {
        companyCamDetailContainer: {
          type: "container",
          flex: "1 0 100%",
          defaults: {
            labelWidth: "7em",
          },
          items: {
            entityCompanyCamContainer: {
              type: "container",
              flex: 1,
              defaults: {
                labelWidth: "7em",
              },
              items: {
                companyCamProjectField: {
                  type: "text",
                  name: "companyCamProject",
                  label: "CompanyCam",
                  cls: 'h-full [&_*]:!cursor-not-allowed',
                  value: "",
                  placeholder: "To view CompanyCam files within Swivu Images or Swivu Documents, select a CompanyCam project.",
                  clearable: true,
                  listeners: {
                    clear: "up.onClearCompanyCamProject",
                  },
                  inputTag: "a",
                  inputAttributes: {
                    target: "_blank",
                    class: "pl-[0.8em] mr-[auto]"
                  },
                }
              },
            },
            companyCamSelectButton: {
              type: "button",
              text: "Select",
              cls: 'swivu-disabled-style text-[#048ded]',
              width: "120px",
              onClick: "up.onSelectCompanyCam",
            },
          }
        },
      }
    }
  }

  loadRecord(parentEntityRecord, context, otherParams) {
    this.parentEntityRecord = parentEntityRecord;
    this.addEntityRecordFromCompanyCamProject = otherParams.addEntityRecordFromCompanyCamProject;
    this.context = context;

    // Get the CompanyCam token from the project
    this.companyCamToken = context.project.extraBoardIntegrationsStore.find((item) => item.key === "companyCam");
    this.setupCompanyCamTokenValue()
  }

  clearCCFieldValue() {
    const { companyCamProjectField} = this.widgetMap;

    companyCamProjectField.input.href = "";
    companyCamProjectField.input.text = "";
    companyCamProjectField.input.classList.remove("!text-[#048ded]");
  }

  async setupCompanyCamTokenValue() {
    const { companyCamProjectField, companyCamSelectButton, } = this.widgetMap;
    const companyCamProjectId = this.parentEntityRecord.companyCamProject;

    if (companyCamProjectId && this.companyCamToken) {
      companyCamProjectField.element.classList.remove('[&_*]:!cursor-not-allowed');
      const projectUrl = `https://app.companycam.com/projects/${companyCamProjectId}`;
      try {
        companyCamProjectField.input.text = "Loading...";
        const res = await getCompanyCamProject(companyCamProjectId, this.companyCamToken.value);
          const projectName = res.data.name;
          companyCamProjectField.input.classList.add("!text-[#048ded]");
          companyCamProjectField.input.href = projectUrl;
          companyCamProjectField.input.text = projectName;
      } catch (e) {
        console.log("CC Project Load Error:", e);
        this.clearCCFieldValue();
        showToast({
          msg: "Something went wrong while loading the CompanyCam project.",
          type: "error",
        })
      }
    } else {
      companyCamSelectButton.disabled = !this.companyCamToken;
      this.clearCCFieldValue();
    }
  }

  onClearCompanyCamProject() {
    const { companyCamProjectField} = this.widgetMap;
    companyCamProjectField.input.href = "";
    companyCamProjectField.input.text = "";
    this.parentEntityRecord.clearCompanyCamProject();
  }

  onSelectCompanyCam() {
    this.context.editorHandler.openEditor(EDITOR_KEYS.companyCampProjectEditor, null, {
        parentEntityRecord: this.parentEntityRecord,
        addEntityRecordFromCompanyCamProject: this.addEntityRecordFromCompanyCamProject,
      },
      { useExisting: true, by: "recordType" });
  }
}

CompanyCamField.initClass();
